export default "__VITE_ASSET__6c5f4c05__"